module.exports = __webpack_public_path__ + "img/card1.d8bc0edd.png";